<template>
  <div class="flex">
    <div
      @click="handleImageClick(item)"
      class="list-item"
      v-for="(item, index) in files"
      :key="index"
      :style="{ backgroundImage: `url(${item})` }"
    >
      <div class="close-wrapper" v-if="!disabled" @click="$emit('remove', index)">
        <div class="icon-close bg-full"></div>
      </div>
    </div>
    <el-upload
      v-if="!disabled"
      :accept="accept"
      :name="name"
      :action="action"
      :on-success="onSuccess"
      :on-error="onError"
      :show-file-list="false"
      multiple
      :disabled="files && files.length >= max"
    >
      <div class="app-upload" :class="[size]" @click="handleClick">
        <div class="upload-icon bg-full"></div>
        <div class="bottom">{{ text }}</div>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { UPLOAD_URL } from '@/utils/const'

export default {
  name: 'MultiUpload',
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    name: {
      type: String,
      default: 'image',
    },
    files: {
      type: Array,
      default: () => [],
    },
    text: String,
    onSuccess: {
      type: Function,
      default: () => {},
    },
    accept: {
      type: String,
      default: 'image/*',
    },
    max: {
      type: Number,
      default: 5,
    },
    disabled: Boolean,
    imageScale: Boolean,
  },
  data() {
    return {
      action: UPLOAD_URL,
    }
  },
  methods: {
    onError(err) {
      this.$message.error('上传图片失败')
    },
    handleClick() {
      if (this.files.length >= this.max) {
        this.$message.warning(`最多上传${5}张图片`)
      }
    },
    handleImageClick(item) {
      if (!this.imageScale) return
      window.open(item, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.list-item {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 24px;
  background: center/contain no-repeat;
  .close-wrapper {
    position: absolute;
    right: 0;
    top: 0;
    width: 32px;
    height: 32px;
    border-radius: 0 0 0 32px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.5);
    .icon-close {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 9px;
      height: 9px;
      background-image: url(~@/assets/img/icon/close2.png);
    }
  }
}
.app-upload {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #fff;
  .img {
    width: 100%;
    height: 100%;
    background: center/cover no-repeat;
  }
  .upload-icon {
    position: absolute;
    width: 37px;
    height: 34px;
    background-image: url(~@/assets/img/icon/upload.png);
    top: 21px;
    left: 50%;
    transform: translateX(-50%);
  }
  .bottom {
    position: absolute;
    width: 100%;
    height: 32px;
    left: 0;
    bottom: 0;
    background: rgba(255, 140, 169, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 22px;
    color: #ffffff;
  }
}
</style>
